import { format, parse, parseISO as parseISODate } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { TimestampString } from './types';

export const nl2br = (string: string) => (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');

export const dateDisplay = (date?: TimestampString, timezone?: string, formatString = 'dd MMMMMM yyyy') => {
  if (!date) {
    return 'Unknown Date';
  }
  let dateInstance;

  if (timezone) {
    dateInstance = date.includes('T') ? laravelToDateWithTimezone(timezone, date) : parse(date, 'yyyy-MM-dd', new Date());
  } else {
    dateInstance = date.includes('T') ? parseISODate(date) : parse(date, 'yyyy-MM-dd', new Date());
  }

  return dateInstance ? format(dateInstance, formatString) : 'Unknown Date';
};

export const dateTimeDisplay = (timezone: string, dateTime?: TimestampString) =>
  dateTime ? format(utcToZonedTime(dateTime, timezone), 'MMM dd yyyy - p') : 'Date to be decided';

export const dateTimeDisplayFuture = (timezone: string, dateTime?: TimestampString) =>
  dateTime ? format(utcToZonedTime(dateTime, timezone), 'cccc MMM dd - p') : 'Date to be decided';

export const laravelToDateWithTimezone = (timezone: string, dateTime: TimestampString) => utcToZonedTime(new Date(dateTime), timezone);

export const customObjValues = (obj) => {
  return Object.keys(obj).map((key) => obj[key]);
};
